/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import ArticleHero from 'flarum/orell-articles/components/ArticleHero';
import ArticlePage from 'flarum/orell-articles/components/ArticlePage';
import type Article from 'flarum/orell-articles/models/Article';
import ArticleBookshelfDropdown from '../components/ArticleBookshelfDropdown';
import ArticleNote from '../components/ArticleNote';
import ArticleStatus from '../components/ArticleStatus';

export default function (): void {
	extend(ArticleHero.prototype, 'controlItems', function (items) {
		const article: Article = this.attrs.article;
		items.add('bookshelf-controls', [<ArticleBookshelfDropdown article={article} />, <ArticleStatus article={article} />]);
	});

	extend(ArticlePage.prototype, 'rightSideItems', function (items) {
		const { article } = this;
		if (article && article.note()) {
			items.add('article-note', <ArticleNote article={article} />);
		}
	});
}
